import React from 'react'
import ChartsContainer from './ChartsContainer'
import Houses from './HousesToRent'

const HomePage = () => {
  return (
    <main>
      <Houses />
      <ChartsContainer />
    </main>
  )
}
 
export default HomePage


